import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { selectCatalogingOnSiteEnabled } from '../../catalog/selectors/CatalogSelectors';
import { contentCountsRequest } from '../../app/actions/spaces/ContentCountsActions';
import { selectContentCounts, selectContentCountsUpToDate } from '../../app/selectors/ContentCountsSelector';
import { selectMixedContentFilterClauses, selectSearchText } from '../../app/selectors/ContentFilterSelectors';
import { selectContentTotalLength } from '../../app/selectors/ContentSelectors';
import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { AppState } from '../../app/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../app/utils/ConnectUtils';
import { SearchSpace, SearchSpaceDispatchProps, SearchSpaceOwnProps, SearchSpaceStateProps } from './SearchSpace';
import { UnifiedSearchSpace, UnifiedSearchSpaceDispatchProps, UnifiedSearchSpaceOwnProps, UnifiedSearchSpaceStateProps } from './UnifiedSearchSpace';

const mapStateToProps: MapStateToProps<UnifiedSearchSpaceStateProps> = (state: AppState) => ({
  urls: siteUrlsSelector(state),
  searchTerm: selectSearchText(state),
  contentFilters: selectMixedContentFilterClauses(state),
  fetchedContentCount: selectContentTotalLength(state),
  isFetchingContent: state.contentExplorer.content.isBusy,
});

const mapDispatchToProps: MapDispatchToProps<UnifiedSearchSpaceDispatchProps> =
  (dispatch) => bindActionCreators({
    fetchUpdatedContentCounts: contentCountsRequest
  },
  dispatch);

export const ConnectedUnifiedSearchSpace: React.ComponentClass<UnifiedSearchSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(UnifiedSearchSpace);
